import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import clsx from "clsx";
import styles from "./evaluationcard.module.scss";
import { snakeToTitleCase } from "../../utils/helper";
import rightTick from "../../assets/images/greentick.png";
import crossTick from "../../assets/images/redcross.png";

type Criterion = {
  label: string;
  score: 0 | 1;
};

type Section = {
  key: string;
  title: string;
  criteria: Criterion[];
};

type EvaluationCardProps = {
  sectionKey: string;
  sectionTitle: string;
  score: number;
  scroreLevel?: "low" | "medium" | "high";
  total: number;
  sections: Section[];
  defaultOpen?: boolean;
};

export const EvaluationCard: React.FC<EvaluationCardProps> = ({
  scroreLevel,
  sectionKey,
  sectionTitle,
  score,
  total,
  sections,
  defaultOpen = false,
}) => {
  // Main expand/collapse state
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const togglePillar = () => {
    setIsOpen((prev) => !prev);
  };
  const percentage = (score / total) * 100;

  const scoreLevel = percentage >= 80 ? "high" : "medium";

  const hasViolations = sections.some((section) =>
    section.criteria.some((c) => c.score === 0)
  );

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader} onClick={togglePillar}>
        <h2 className={styles.cardTitle}>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          {sectionTitle}
        </h2>
        <div className={styles.scoreContainer}>
          <span
            className={clsx(
              styles.score,
              // scoreLevel === "low" && styles.low,
              // scoreLevel === "medium" && styles.medium,
              // scoreLevel === "high" && styles.high
              hasViolations ? styles.medium : styles.high
            )}
          >
            {hasViolations ? "NEEDS REVIEW" : "NO VIOLATIONS"}
          </span>
        </div>
      </div>

      {isOpen && (
        <div className={styles.cardContent} style={{ display: "flex" }}>
          {sections.map((section, idx) => (
            <div
              key={idx}
              className={styles.section}
              style={{ marginRight: "70px" }}
            >
              {section.criteria.map((c, i) => (
                <table key={i}>
                  <tbody>
                    <tr key={i}>
                      <td className={styles.firstRow}>
                        {section.key === "dos" ? "Do's" : "Don'ts"}:{" "}
                        {snakeToTitleCase(c.label)}
                      </td>
                      <td className={styles.td}>
                        {/* {c.score}/1 */}
                        {c.score === 1 ? (
                          <img
                            src={rightTick}
                            alt="Preview"
                            style={{
                              width: "25px",
                              height: "auto",
                            }}
                          />
                        ) : (
                          <img
                            src={crossTick}
                            alt="Preview"
                            style={{
                              width: "25px",
                              height: "auto",
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ))}
              {/* <h3 className={styles.sectionTitle}>{section.title}</h3>
              <table className={styles.table}>
                <thead className={styles.scoreRow}>
                  <tr>
                    <th className={styles.th}>Criterion</th>
                    <th className={styles.th}>Score</th>
                  </tr>
                </thead>
                <tbody>
                  {section.criteria.map((c, i) => (
                    <tr key={i}>
                      <td>{snakeToTitleCase(c.label)}</td>
                      <td className={styles.td}>{c.score}/1</td>
                    </tr>
                  ))}
                </tbody>
              </table> */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EvaluationCard;
